module.exports = __webpack_public_path__ + "static/media/printer.01c4c398.png";